<template>
  <div class="register">
    <div class="container">
      <div class="row-between" style="align-items: flex-end">
        <img
          style="width: 228px; height: 52px; padding: 46px 0 16px 0"
          src="../assets/images/header_logo.png"
        />
        <p class="register-help">
          {{ $t("Have an Account") }}，<span @click="goLogin">{{
            $t("Sign in Now")
          }}</span>
          |
          <span @click="goHome">{{ $t("Homepage") }}</span>
        </p>
      </div>
      <div class="register-form-box">
        <!-- <p class="register-title">{{ $t("Join Free") }}</p> -->
        <div class="register-form">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="170px"
            class="demo-ruleForm"
          >
            <el-form-item :label="$t('Name') + '：'" prop="name">
              <el-input
                :placeholder="$t('Please enter your Name')"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Company') + '：'" prop="company">
              <el-input
                :placeholder="$t('Please enter your Company')"
                v-model="ruleForm.company"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Job Title') + '：'" prop="duty">
              <el-input
                :placeholder="$t('Please enter your Job Title')"
                v-model="ruleForm.duty"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Country/Region') + '：'" prop="country">
              <div class="row-between">
                <el-select
                  v-model="ruleForm.country"
                  :placeholder="$t('Country')"
                >
                  <el-option label="中国" value="中国"></el-option>
                  <el-option label="台湾" value="taiwan"></el-option>
                </el-select>
                <el-select
                  v-model="ruleForm.province"
                  :placeholder="$t('Region')"
                >
                  <el-option label="河北省" value="河北省"></el-option>
                  <el-option label="陕西省" value="陕西省"></el-option>
                  <el-option label="辽宁省" value="辽宁省"></el-option>
                  <el-option label="山西省" value="山西省"></el-option>
                  <el-option label="吉林省" value="吉林省"></el-option>
                  <el-option label="黑龙江省" value="黑龙江省"></el-option>
                  <el-option label="浙江省" value="浙江省"></el-option>
                  <el-option label="安徽省" value="安徽省"></el-option>
                  <el-option label="福建省" value="福建省"></el-option>
                  <el-option label="江西省" value="江西省"></el-option>
                  <el-option label="山东省" value="山东省"></el-option>
                  <el-option label="河南省" value="河南省"></el-option>
                  <el-option label="湖北省" value="湖北省"></el-option>
                  <el-option label="湖南省" value="湖南省"></el-option>
                  <el-option label="广东省" value="广东省"></el-option>
                  <el-option label="海南省" value="海南省"></el-option>
                  <el-option label="四川省" value="四川省"></el-option>
                  <el-option label="贵州省" value="贵州省"></el-option>
                  <el-option label="云南省" value="云南省"></el-option>
                  <el-option label="甘肃省" value="甘肃省"></el-option>
                  <el-option label="青海省" value="青海省"></el-option>
                  <el-option label="台湾省" value="台湾省"></el-option>
                  <el-option label="内蒙古" value="内蒙古"></el-option>
                  <el-option label="广西" value="广西"></el-option>
                  <el-option label="西藏" value="西藏"></el-option>
                  <el-option label="宁夏" value="宁夏"></el-option>
                  <el-option label="新疆" value="新疆"></el-option>
                  <el-option label="北京" value="北京"></el-option>
                  <el-option label="天津" value="天津"></el-option>
                  <el-option label="上海" value="上海"></el-option>
                  <el-option label="重庆" value="重庆"></el-option>
                  <el-option label="香港" value="香港"></el-option>
                  <el-option label="澳门" value="澳门"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Company Type') + '：'" prop="status">
              <el-select
                v-model="ruleForm.status"
                :placeholder="$t('Please choose  your Company Type')"
              >
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Interest') + '：'" prop="programe">
              <el-checkbox-group v-model="ruleForm.programe">
                <el-checkbox
                  :label="$t('Complete Bikes')"
                  name="1"
                ></el-checkbox>
                <el-checkbox
                  :label="$t('Frames,Forks & Parts')"
                  name="2"
                ></el-checkbox>
                <el-checkbox
                  :label="$t('Tires,Rims & Parts')"
                  name="3"
                ></el-checkbox>
                <el-checkbox
                  :label="$t('Transmissions & Parts')"
                  name="4"
                ></el-checkbox>
                <el-checkbox
                  :label="$t('Steering & Components')"
                  name="5"
                ></el-checkbox>
                <el-checkbox :label="$t('Accessories')" name="6"></el-checkbox>
                <el-checkbox
                  :label="$t('Machinery & Tools')"
                  name="7"
                ></el-checkbox>
                <el-checkbox
                  :label="$t('Cycling/Outdoor Products')"
                  name="8"
                ></el-checkbox>
                <el-checkbox
                  :label="$t('Electric Bicycle')"
                  name="9"
                ></el-checkbox>
                <el-checkbox
                  :label="$t('Components & Parts Of E-Bike')"
                  name="10"
                ></el-checkbox>
                <el-checkbox
                  :label="$t('Motor Cycle/Motor Parts')"
                  name="11"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item :label="$t('Mobile/E-mail') + '：'" prop="username">
              <el-input
                :placeholder="$t('Please enter your Mobile or E-mail')"
                v-model="ruleForm.username"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="name">
              <div class="drag">
                <div class="drag_bg"></div>
                <div class="drag_text">{{ confirmWords }}</div>
                <div
                  @mousedown="mousedownFn($event)"
                  class="handler handler_bg"
                ></div>
              </div>
            </el-form-item>
            <el-form-item class="form-item" prop="code">
              <el-input
                :placeholder="$t('Verification Code')"
                v-model="ruleForm.code"
              >
                <template slot="append">{{ btnTxt }}</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('Password') + '：'" prop="password">
              <el-input
                type="password"
                :placeholder="$t('Please enter your Password')"
                v-model="ruleForm.password"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Confirm Password') + '：'"
              prop="repassword"
            >
              <el-input
                type="password"
                :placeholder="$t('Please enter your Password again')"
                v-model="ruleForm.repassword"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div></div>
              <el-button
                style="width: 100%"
                type="primary"
                @click="submitForm('ruleForm')"
                >{{ $t("Submit & Continue") }}</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked">
                <span style="color: #619a37">{{ $t("I Agree") }}</span>
              </el-checkbox>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="site-container">
        <div class="site-info">
          <div style="margin-bottom: 14px; font-size: 16px; cursor: pointer">
            {{ $t("About Us") }} | {{ $t("For Suppliers") }} |
            {{ $t("For Buyers") }} |
            <span @click="gomedia">{{ $t("Media Cooperation") }}</span> |
            {{ $t("Online Exhibition") }} | {{ $t("Send Massage") }} |
            {{ $t("Download") }}
          </div>
          <div style="font-size: 12px">
            e-chinacycle.com All rights reserved. 沪ICP备11048102号-1 沪公网安备
            31010702001213
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/EventBus.js";
import { sendSMS, createAccount, bindAccount } from "@/http/api";
export default {
  data() {
    let phoneReg =
      /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    let checkPhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    // let codeReg = /^\d{6}$/;
    let checkCode = (rule, value, callback) => {
      console.log(this.codeNum, value);
      if (value != this.codeNum) {
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        name: "",
        company: "",
        duty: "",
        country: "",
        province: "",
        username: "",
        password: "",
        repassword: "",
        code: "",
        programe: [],
      },
      checked: false,
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司", trigger: "change" }],
        duty: [
          {
            required: true,
            message: "请输入职位",
            trigger: "change",
          },
        ],
        country: [
          {
            required: true,
            message: "请选择国家",
            trigger: "change",
          },
        ],
        province: [
          {
            required: true,
            message: "请选择省份",
            trigger: "change",
          },
        ],
        username: [
          { required: true, validator: checkPhone, trigger: "change" },
        ],
        code: [{ validator: checkCode, trigger: "change" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        repassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
      beginClientX: 0,
      /*距离屏幕左端距离*/
      mouseMoveStata: false,
      /*触发拖动状态 判断*/
      maxwidth: 308,
      /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords: this.$t("Please drag the slider to the right side"),
      /*滑块文字*/
      confirmSuccess: false /*验证成功判断*/,
      btnTxt: this.$t("Send Code"),
      time: 60,
      codeNum: "",
    };
  },

  methods: {
    gomedia() {
      this.$router.push("/commedia");
    },
    goLogin() {
      this.$router.push("/login");
    },
    goHome() {
      this.$router.push("/");
    },
    countDown() {
      let intervalId;
      intervalId = setInterval(() => {
        this.time--;
        this.btnTxt = this.time + "s";
        if (this.time > 0 && this.time < 60) {
        } else {
          clearInterval(intervalId);
          this.time = 0;
          this.btnTxt = "获取验证码";
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (!this.confirmSuccess)
            return this.$message.error("请拖动滑块验证");
          if (!this.checked) return this.$message.error("请同意服务条款");
          const res = await createAccount({
            username: this.ruleForm.username,
            password: this.ruleForm.password,
          });
          if (!res) return this.$message.error("创建账户失败");
          const response = await bindAccount(res.id, this.ruleForm);
          if (!response) return this.$message.error("绑定账户失败");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    mousedownFn: function (e) {
      this.mouseMoveStata = true;
      this.beginClientX = e.clientX;
    }, //按下滑块函数
    async successFunction() {
      if (!this.ruleForm.username) return this.$message.error("请输入用户名");
      $(".handler").removeClass("handler_bg").addClass("handler_ok_bg");
      this.confirmWords = "验证通过";
      $(".drag").css({
        color: "#fff",
      });
      $(".drag").css({
        "background-color": "#619a37",
      });
      $(".handler").css({
        left: this.maxwidth,
      });
      $(".drag_bg").css({
        width: this.maxwidth,
      });
      $("body").unbind("mousemove");
      $("body").unbind("mouseup");
      this.confirmSuccess = true;
      //验证成功
      this.countDown();
      const res = await sendSMS(this.ruleForm.username);
      if (!res) return;
      this.codeNum = res;
    },
  },
  created() {
    EventBus.$emit("switchTab", -1);
  },
  mounted() {
    $("body").on("mousemove", (e) => {
      //拖动，这里需要用箭头函数，不然this的指向不会是vue对象
      if (this.mouseMoveStata) {
        var width = e.clientX - this.beginClientX;
        if (width > 0 && width <= this.maxwidth) {
          $(".handler").css({
            left: width,
          });
          $(".drag_bg").css({
            width: width,
          });
        } else if (width > this.maxwidth) {
          this.successFunction();
        }
      }
    });
    $("body").on("mouseup", (e) => {
      //鼠标放开
      this.mouseMoveStata = false;
      var width = e.clientX - this.beginClientX;
      if (width < this.maxwidth) {
        $(".handler").css({
          left: 0,
        });
        $(".drag_bg").css({
          width: 0,
        });
      }
    });
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 20px;
  max-width: 900px;
  margin: 80px auto 0;
}
.site-container {
}
.site-info {
  width: 900px;
  margin: 0 auto;
  text-align: center;
  padding: 19px 0;
  color: #999999;
}
.register {
  background-color: #eaeaea;
}
.register-title {
  font-size: 24px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #ffffff;
  background-color: #508429;
  padding: 26px 0;
  text-align: center;
}
.container {
  width: 900px;
  margin: 0 auto;
}
.register-form-box {
  background-color: #ffffff;
}
.register-form {
  padding: 30px 200px;
}
/deep/ .el-input__inner {
  background-color: #f4f4f4;
}
.drag {
  border-radius: 5px;
  position: relative;
  background-color: #e8e8e8;
  width: 100%;
  height: 34px;
  margin-top: 30px;
  margin-bottom: 30px;
  line-height: 34px;
  text-align: center;
}
.handler {
  border-radius: 5px;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 40px;
  height: 32px;
  border: 1px solid #ccc;
  cursor: move;
}
.handler_bg {
  background: #fff
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==")
    no-repeat center;
}
.handler_ok_bg {
  background: #fff
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==")
    no-repeat center;
}
.drag_bg {
  border-radius: 5px;
  background-color: #619a37;
  height: 34px;
  width: 0px;
}
.drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
}
/deep/ .el-button--primary {
  background-color: #619a37;
  border-color: unset;
}
.register-help {
  font-size: 14px;
  font-family: FZLanTingHei-R-GB18030;
  font-weight: 400;
  color: #444444;
  margin-bottom: 24px;
  span {
    color: #619a37;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/register.vue